class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
      // if($('body').hasClass('temp_product')){
      // $(".product__info-container .icon_slider_cart_drawer").flickity('destroy');
      // $(".product__info-container .icon_slider_cart_drawer").flickity({
      //   wrapAround: true,
      //   groupCells: false,
      //   prevNextButtons: false,
      //   pageDots: false,
      //   selectedAttraction: 0.01,
      //   friction: 0.15
      // });
      // }
//       setTimeout(() => {
//               $("#CartDrawer .icon_slider_cart_drawer").flickity({
//   wrapAround: true,
//   groupCells: false,
//   autoPlay: 5000,
//   prevNextButtons: false,
//   pageDots: false,
//   selectedAttraction: 0.01,
//   friction: 0.15
// });});

setTimeout(() => {
  const $slider = $("#CartDrawer .icon_slider_cart_drawer");

  $slider.flickity({
    wrapAround: true,
    groupCells: false,
    autoPlay: 3000,
    prevNextButtons: false,
    pageDots: false,
    selectedAttraction: 0.01,
    friction: 0.15,
    cellAlign: 'center' 
  });

 
  setTimeout(() => {
    $slider.flickity('resize');
  }, 100);
}, 100);

    
    document.body.classList.add('overflow-hidden');
    $('.phase_select_drawer_outer').removeClass('open');
    $('.phase_select_drawer_outer').find('.phase_select_tabs_wrapper_content_tabbed').removeClass('show_tab').siblings().addClass('show_tab');
    
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
      //     if($('body').hasClass('temp_product')){
      //       $(".product__info-container .icon_slider_cart_drawer").flickity('destroy');
      // $(".product__info-container .icon_slider_cart_drawer").flickity({
      //   wrapAround: true,
      //   groupCells: false,
      //   autoPlay: 5000,
      //   prevNextButtons: false,
      //   pageDots: false,
      //   selectedAttraction: 0.009,
      //   friction: 0.15
      // });
      // }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
 
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);








